export const TIME_MASK = [/\d/, /\d/]

const MAX_HOUR_VALUE = 12
const MIN_HOUR_VALUE = 1
const MAX_MINUTES_VALUE = 59

const MAX_VALUE_TO_FORMAT = 10

interface GetTimeValueProps {
  isPM: boolean
  time: string
}

const getValidHourValue = (hourValue: number) => {
  const updatedHourValue = Math.min(Math.max(hourValue, MIN_HOUR_VALUE), MAX_HOUR_VALUE)
  const validHourValue =
    updatedHourValue >= MAX_VALUE_TO_FORMAT ? updatedHourValue : `0${updatedHourValue}`

  return validHourValue
}

const getValidMinuteValue = (minutesValue: number) => {
  const updatedMinuteValue = Math.min(minutesValue, MAX_MINUTES_VALUE)
  const validMinuteValue =
    updatedMinuteValue >= MAX_VALUE_TO_FORMAT ? updatedMinuteValue : `0${updatedMinuteValue}`

  return validMinuteValue
}

export const getInitialDisplayedTime = (time: string) => {
  const [hour, minutes] = time.split(':')
  const hourValue = Number(hour)
  const minutesValue = Number(minutes) || 0
  const isPM = hourValue >= MAX_HOUR_VALUE
  const formattedHour = hourValue % 24

  const validHour = getValidHourValue(formattedHour % MAX_HOUR_VALUE || MAX_HOUR_VALUE)
  const validMinutes = getValidMinuteValue(minutesValue)

  return {
    displayTime: `${validHour}:${validMinutes}`,
    isPM,
  }
}

export const getTimeValue = ({ isPM, time }: GetTimeValueProps) => {
  const [hour, minutes] = time.split(':')
  const hourValue = Number(hour)
  const minutesValue = Number(minutes) || 0
  const isoHourValue = hourValue === MAX_HOUR_VALUE ? 0 : hourValue

  if (isPM) {
    const updatedIsoHourValue = isoHourValue + MAX_HOUR_VALUE
    return `${updatedIsoHourValue}:${minutes}`
  }

  const validHour = isoHourValue >= MAX_VALUE_TO_FORMAT ? isoHourValue : `0${isoHourValue}`
  const validMinutes = getValidMinuteValue(minutesValue)

  return `${validHour}:${validMinutes}`
}

export const getValidDisplayedTime = (time: string) => {
  const [hour, minutes] = time.split(':')
  const hourValue = Number(hour || MAX_HOUR_VALUE)
  const minutesValue = Number(minutes) || 0

  const validHour = getValidHourValue(hourValue)
  const validMinutes = getValidMinuteValue(minutesValue)

  return `${validHour}:${validMinutes}`
}
